import React from 'react';
import { connect } from 'react-redux';
import { Header } from 'semantic-ui-react';
import { withRouter } from 'react-router';

import 'PageStyles/home/index.less';

class HomeContainer extends React.Component {
  render() {
    return (
      <div className="home--wrapper" style={{ padding: '2rem' }}>
        <Header as="h2">
          <Header.Content
            className="text-primary"
            content={`Welcome ${
              !this.props.userInfo.firstName ||
              this.props.userInfo.firstName.length === 0
                ? ``
                : this.props.userInfo.firstName + `, `
            }to Meals Plus Web!`}
          />
        </Header>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userInfo: state.SecurityState.userInfo,
  };
};

export const Home = withRouter(connect(mapStateToProps)(HomeContainer));



// WEBPACK FOOTER //
// ./src/pages/home/Home.js